import { render } from "./SearchBox.vue?vue&type=template&id=7af1b1ca&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=7af1b1ca&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af1b1ca"]])

export default __exports__